export default __webpack_public_path__ + "static/media/ios-arrow-up.55e9f2cc.svg";